export function greeting(environment: string): string {
  return environment === "production" ? "Obean" : `Obean (${environment})`;
}
